import { SOMETHING_WENT_WRONG } from "../features/driverDetails/messages";

export const getErrorMessage = (error) =>
  error
    ? error.message || error.error?.message || SOMETHING_WENT_WRONG
    : SOMETHING_WENT_WRONG;
